import { HTTP } from '../../http-common';
import { createHelpers } from 'vuex-map-fields';
import { Order } from '../../models/Order';
import { httpError } from '../../models/httpError';
import { getField, updateField } from 'vuex-map-fields';

export const { mapFields: mapOrderFields } = createHelpers({
  getterType: `orders/getField`,
  mutationType: `orders/updateField`,
});

export const { mapMultiRowFields: mapOrderMultiRowFields } = createHelpers({
  getterType: `orders/getField`,
  mutationType: `orders/updateField`,
});

//import order from './forms/order';
import auth from './forms/auth';
import customer from './forms/customer';
import dealer from './forms/dealer';
import company from './forms/company';
import newChurn from './forms/NewChurn';
import landline from './forms/Landline';
import address from './forms/address';
import ratePlan from './forms/ratePlan';
import summary from './forms/summary';
import internet from './forms/Internet';
import otherCharges from './forms/otherCharges';
import isdn from './forms/NewISDN';
import pstn from './forms/NewPSTN';
import ipVoice from './forms/IPVoice';
import notes from './forms/note';
import hardware from './forms/hardware';
import handset from './forms/handset';
import termsConditions from './forms/termsConditions';
import porting from './forms/porting';
import uploads from './forms/uploads';
import { DirectDebit } from '../../models/DirectDebit';
import financeApplication from './forms/financeApplication';
import Sip from './forms/sip';
import Teams from './forms/teams';
import mobile from './forms/VonexMobile';
import inbound from './forms/Inbound';
import menu from './forms/menu';
import fax from './forms/fax';
import Cmc from './forms/Cmc';
import routes from './forms/vueRouter';
import dealerPortal from './forms/DealerPortal';
import audit from './forms/audit';
import relocation from './forms/relocation';
import changeLessee from './forms/changeLessee';
import utility from './forms/utility';
import notifications from './forms/notifications';
import qantas from './forms/qantas';
import quote from './forms/quote';
import sq from './forms/sq';
import sqAddress from './forms/SQAddress';
import { Quote } from '../../models/Quote';
import featureFlag from './forms/featureFlag';
import installationCharges from './forms/installationCharges';

const actions = {
  getAuth({ dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.get('GetAuthorisation')
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error getting Auths:' + err,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },

  addDataBackup({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post('/Dealer/AddDataBackup', payload);

      response
        .then(function (data) {
          var resultData = data;
          dispatch(
            'setMessage',
            new httpError({
              httpStatus: 200,
              message: 'Data saved successfully!',
            })
          );
          resolve(resultData);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Save failed: ' + err,
              httpStatus: 500,
            })
          );
          reject();
        });
    });
  },

  updateSignature({ commit, dispatch }, signature) {
    return new Promise((resolve, reject) => {
      let header = HTTP.defaults.headers.common.Authorization;
      delete HTTP.defaults.headers.common.Authorization;
      var response = HTTP.post('/Order/addSignature/', signature);
      response
        .then(function (data) {
          HTTP.defaults.headers.common.Authorization = header;
          var resultData = data.data;
          commit('setSignature', signature.data);
          dispatch(
            'setMessage',
            new httpError({
              message: 'Updated OK',
              httpStatus: 200,
            })
          );
          resolve(resultData);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error: ' + err,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  getDealerAuthLevel({ commit }, payload) {
    return new Promise((resolve, reject) => {
      HTTP.get(`Auth/GetDealerAuthLevel/${payload}`)
        .then((data) => {
          commit('setIsDirectSales', data.data.authLevel == 5);
          resolve(data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDealerFromEmail({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.post('Order/getDealerFromEmail', {
        email: 'guest',
      })
        .then((data) => {
          dispatch('getDealerAuthLevel', data.data.dealerID);
          commit('orders/dealer/setDealer', data.data, {
            root: true,
          });
          resolve(data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  reprocessOrder({ commit, dispatch }, envelopeID) {
    commit('setReprocessOrderDialog', true);

    setTimeout(function () {
      return new Promise((resolve, reject) => {
        HTTP.post(`Docusign/reprocess/${envelopeID}`)
          .then(function (data) {
            if (data.status == 200) {
              commit('setReprocessOrderDialog', false);
              dispatch(
                'setMessage',
                new httpError({
                  message: 'Order has been reprocessed!',
                  httpStatus: 200,
                })
              );
              resolve(data.data);
            } else reject('Unable to reprocess order!');
          })
          .catch((err) => {
            commit('setReprocessOrderDialog', false);
            dispatch(
              'setMessage',
              new httpError({
                message: 'Error in reprocessing order : ' + err.message,
                httpStatus: 500,
              })
            );
            reject(err);
          });
      });
    }, 500);
  },

  getContacts({ commit, dispatch }, orderID) {
    return new Promise((resolve, reject) => {
      HTTP.get('order/GetContacts/' + orderID)
        .then(function (data) {
          if (data.status == 200) {
            commit('setOrderContacts', data.data);
            commit(
              'setProgress',
              new httpError({
                message: 'Contacts Retrieved',
                httpStatus: 200,
              })
            );
            resolve(data.data);
          } else reject('No Content');
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error in retrieving Contacts : ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  removeContact({ commit, dispatch, rootState }, contact) {
    return new Promise((resolve, reject) => {
      HTTP.delete(
        'order/DeleteContactsFromOrder/' + rootState.orders.rows[0].orderID,
        {
          data: [contact],
        }
      )
        .then(() => {
          commit('removeContact', contact);
          resolve();
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'unable to save:' + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
  },
  saveContact({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      HTTP.post(`order/AddOrderContact/${data.orderID}`, data.contact)
        .then((res) => {
          commit('setOrderContacts', res.data);
          dispatch(
            'setMessage',
            new httpError({
              message: 'Saved OK',
              httpStatus: 200,
            })
          );
          resolve(res.data[res.data.length - 1]);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'unable to save:' + err,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  resetOrder({ commit, dispatch }) {
    return new Promise((resolve) => {
      dispatch('menu/reset');
      dispatch('customer/resetCustomer');
      dispatch('newChurn/resetNewChurn');
      dispatch('address/resetAddress');
      dispatch('company/resetCompany');
      dispatch('landline/resetLandline');
      dispatch('pstn/resetPstn');
      dispatch('isdn/resetISDN');
      dispatch('ipVoice/resetIPVoice');
      dispatch('summary/resetSummary');
      dispatch('notes/resetNotes');
      dispatch('ratePlan/getRatePlans');
      dispatch('internet/resetInternet');
      dispatch('hardware/reset');
      dispatch('termsConditions/reset');
      dispatch('porting/reset');
      dispatch('uploads/reset');
      dispatch('Sip/reset');
      dispatch('Teams/reset');
      dispatch('mobile/reset');
      dispatch('inbound/reset');
      dispatch('fax/reset');
      dispatch('Cmc/reset');
      dispatch('routes/reset');
      dispatch('financeApplication/reset');
      dispatch('relocation/reset');
      dispatch('changeLessee/reset');
      dispatch('utility/reset');
      dispatch('notifications/reset');
      dispatch('audit/reset');
      dispatch('setMessage', new httpError());

      commit('setOrder', new Order());
      resolve();
    });
  },
  getTrainingLinks({ dispatch }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get('Order/GetTrainingLinks/'); // 4 = cancelled
      response
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  updatedFinanceHardware({ commit, state, dispatch }, data) {
    return new Promise((resolve, reject) => {
      var response = HTTP.put(
        'Order/UpdateFinanceHardware/' + state.rows[0].orderID,
        data
      );
      response
        .then((data) => {
          commit('setFinanceHardware', data.data.financedHardware);
          dispatch(
            'setMessage',
            new httpError({
              message: 'Hardware has been financed',
              httpStatus: 200,
            })
          );
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error updating ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
  },
  updateOrderType({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      HTTP.put('Order/UpdateOrderType/' + data.orderID + '/' + data.type)
        .then(function (data) {
          var resultData = data.data;
          dispatch(
            'setMessage',
            new httpError({
              message: 'Order :' + data.orderID + ' has been updated.',
              httpStatus: 200,
            })
          );
          resolve(resultData);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  updateOrder({ commit, dispatch }, order) {
    return new Promise((resolve, reject) => {
      var response = HTTP.put('Order/UpdateOrder/' + order.orderID, order); // 4 = cancelled
      response
        .then(function (data) {
          var resultData = data.data;

          if (resultData.orderStatus == 4) {
            HTTP.put('Docusign/VoidDocusignEnvelope/' + order.orderID)
              .then(() => {
                resolve(resultData);
              })
              .catch((err) => {
                reject(err);
              });
          }
          commit('setOrder', resultData);
          dispatch(
            'setMessage',
            new httpError({
              message: 'Order :' + order.orderID + ' has been updated.',
              httpStatus: 200,
            })
          );
          resolve(resultData);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  removeOrder({ commit, dispatch }, orderID) {
    return new Promise((resolve, reject) => {
      if (orderID === 0) {
        reject('no orderID');
        return;
      }
      var response = HTTP.put('Order/CancelOrder/' + orderID);
      response
        .then(function (data) {
          var resultData = data.data;
          HTTP.put('Docusign/CancelOrderAndVoidDocusignEnvelope/' + orderID)
            .then(() => {
              commit('setOrder', resultData);
              dispatch(
                'setMessage',
                new httpError({
                  message: 'Order :' + orderID + ' has been cancelled.',
                  httpStatus: 200,
                })
              );
              resolve(resultData);
            })
            .catch((err) => {
              reject(err);
            });
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  addOrder({ commit, dispatch, rootState, state }, payload) {
    return new Promise((resolve, reject) => {
      if (payload.customerID === 0) {
        reject('no customerID');
        return;
      }
      var dealerID =
        payload.dealerID && payload.dealerID > 0
          ? payload.dealerID
          : rootState.orders.dealer.dealer.dealerID;
      var order = new Order();
      order.dealerID = dealerID;
      order.customerID = payload.customerID;
      order.orderType = payload.type;
      order.isQuote = state.isQuote;
      order.existingCustomer = rootState.orders.rows[0].existingCustomer;
      var response = HTTP.post('Order/CreateOrder', order);
      response
        .then(function (data) {
          if (data.status == 204) {
            dispatch(
              'setMessage',
              new httpError({
                message: 'Unable to create order',
                httpStatus: 500,
              })
            );
            return resolve();
          }

          var resultData = data.data;
          dispatch('resetOrder');
          commit('setOrder', resultData);
          commit('orders/customer/setCustomer', resultData.customerDetails, {
            root: true,
          });
          if (resultData.customerDetails !== null) {
            commit(
              'orders/address/setAddress',
              resultData.customerDetails.addressDetails[0],
              {
                root: true,
              }
            );
            commit(
              'orders/address/setAddresses',
              resultData.customerDetails.addressDetails,
              {
                root: true,
              }
            );
          }

          if (state.isQuote) {
            let quote = new Quote();
            quote.orderID = resultData.orderID;

            dispatch('orders/quote/saveQuoteDetail', quote, {
              root: true,
            });
          }
          dispatch('orders/getContacts', rootState.orders.rows[0].orderID, {
            root: true,
          });

          resolve(resultData);
          //dispatch("getOrder", resultData.orderID).then(data => {
          //   // dispatch('orders/address/getAddress', resultData.customerDetails.addressID, { root: true });
          //    resolve(resultData);
          //});
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error: ' + err,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  addSoftPhoneOrder({ dispatch }, details) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(
        'Order/AddSoftphoneOrderToCustomer/' + details.customer,
        details.extensions
      );
      response
        .then(function (data) {
          var resultData = data.data;
          dispatch(
            'setMessage',
            new httpError({
              message: 'Order Processed ',
              httpStatus: 200,
            })
          );
          resolve(resultData);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error: ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  listOrders({ dispatch }, orderID) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get('Order/GetOrders/' + orderID);
      response
        .then(function (data) {
          var resultData = data.data;
          dispatch(
            'setMessage',
            new httpError({
              message: 'Orders retrieved ',
              httpStatus: 200,
            })
          );
          resolve(resultData);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error: ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  listAllOrders({ dispatch }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get('Order/GetAllOrders');
      response
        .then(function (data) {
          var resultData = data.status == 204 ? [] : data.data;
          resolve(resultData);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error: ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  paginatedlistAllOrders({ dispatch }, query) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post('Order/GetPaginatedtOrdersList', query);
      response
        .then(function (data) {
          var resultData = data.status == 204 ? [] : data.data;
          resolve(resultData);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error: ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  listDelayedOrders() {
    return new Promise((resolve, reject, dispatch) => {
      var response = HTTP.get('Order/GetAllDelayedOrders');
      response
        .then(function (data) {
          var resultData = data.data;
          resolve(resultData);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error: ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  listInProgressOrders() {
    return new Promise((resolve, reject) => {
      var response = HTTP.get('Order/GetAllInProgressOrders');
      response
        .then(function (data) {
          var resultData = data.data;
          resolve(resultData);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async sendInProgressOrders({ dispatch }, email, time) {
    var response = await HTTP.post(
      'Order/SendReportOrdersInProgress',
      email,
      time
    );
    if (response.status == 200) {
      dispatch(
        'setMessage',
        new httpError({
          message: 'Message Sent',
          httpError: 200,
        })
      );
      return new Promise.resolve();
    }
  },
  async resubmitOrderToKayako({ dispatch }, orderID) {
    try {
      var data = await HTTP.post('Order/ResendToKayako/' + orderID);
      if (data.status == 200) {
        dispatch(
          'setMessage',
          new httpError({
            message: 'resubmitted',
            httpError: 200,
          })
        );
        return new Promise.resolve();
      }
    } catch (error) {
      dispatch(
        'setMessage',
        new httpError({
          message: 'not resubmitted: ' + error.message,
          httpError: 500,
        })
      );
      return new Promise.reject();
    }
  },
  async getOrder({ commit, dispatch }, orderID) {
    return new Promise((resolve, reject) => {
      dispatch('resetOrder');
      HTTP.get('Order/GetOrders/' + orderID)
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error: ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        })
        .then((data) => {
          if (data.data) {
            let resultData = data.data[0];
            //commit("setOrder", resultData);
            commit('setOrder', resultData);
            dispatch('orders/menu/getStatus', null, {
              root: true,
            });
            commit('orders/customer/setCustomer', resultData.customerDetails, {
              root: true,
            });
            if (resultData.customerDetails.addressDetails.length > 0) {
              commit(
                'orders/address/setAddress',
                resultData.customerDetails.addressDetails[0],
                {
                  root: true,
                }
              );
              commit(
                'orders/address/setAddresses',
                resultData.customerDetails.addressDetails,
                {
                  root: true,
                }
              );
            }
            if (resultData.customerDetails.companyID > 0) {
              commit(
                'orders/company/setCompany',
                resultData.customerDetails.companyDetails,
                {
                  root: true,
                }
              );
            }
            dispatch('getContacts', orderID);
            dispatch('orders/uploads/populateUploads', orderID, {
              root: true,
            });
            if (resultData.orderView && resultData.orderView.iPOrder) {
              dispatch('orders/ipVoice/getIPExtensions', null, {
                root: true,
              });
            }

            dispatch(
              'setMessage',
              new httpError({
                message: 'Order retreived',
                httpStatus: 200,
              })
            );
            resolve(resultData);
          }
        });
    });
  },
  addLandline({ commit, state }, landline) {
    commit('setLandline', landline.landlineID);
    return new Promise((resolve, reject) => {
      var response = HTTP.post(
        'Order/addLandlineOrder/' + state.rows[0].orderID,
        landline
      );
      response
        .then(function (data) {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getDirectDebit({ commit, state }) {
    return new Promise((resolve) => {
      if (state.rows[0].directDebit == null)
        commit('setDirectDebit', new DirectDebit());

      let details = state.rows[0].directDebit;
      let hasExisting =
        state.customer.customer.directDebit === 'Yes' &&
        state.rows[0].existingCustomer
          ? true
          : false;
      commit('setHasDirectDebit', hasExisting);

      if (hasExisting && state.customer.customer.directDebit) {
        if (
          !details.useExisting &&
          !details.accountName &&
          !details.payWithCreditCard &&
          !details.noDetailsProvided
        ) {
          commit('setDDOption', 1);
        } else if (
          !details.useExisting &&
          !details.payWithCreditCard &&
          !details.noDetailsProvided
        ) {
          commit('setDDOption', 2);
        } else if (details.useExisting) {
          commit('setDDOption', 1);
        } else if (details.payWithCreditCard) {
          commit('setDDOption', 3);
        } else {
          commit('setDDOption', 4);
        }
      } else {
        if (details.payWithCreditCard) {
          commit('setDDOption', 3);
        } else if (!details.noDetailsProvided) {
          commit('setDDOption', 2);
        } else if (details.noDetailsProvided) {
          commit('setDDOption', 4);
        }
      }
      resolve(state.rows[0].directDebit);
    });
  },
  updateDirectDebit({ commit, state, dispatch }, directDebit) {
    return new Promise((resolve, reject) => {
      var response = HTTP.put(
        'Order/updateDirectDebit/' + state.rows[0].orderID,
        directDebit
      );
      response
        .then((data) => {
          commit('setDirectDebit', data.data);
          dispatch(
            'setMessage',
            new httpError({
              message: 'Direct Debit info updated',
              httpStatus: 200,
            })
          );
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error updating ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
  },
  removeDirectDebit({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      commit('setDirectDebit', null);
      dispatch('updateDirectDebit')
        .then(() => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Direct Debit info updated',
              httpStatus: 200,
            })
          );
          resolve();
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error updating ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  voidEnvelope(order) {
    return new Promise((resolve, reject) => {
      if (order && order.orderID) {
        HTTP.put('Docusign/VoidDocusignEnvelope/' + order.orderID)
          .then((data) => {
            resolve(data.data);
          })
          .catch((err) => {
            reject(err);
          });
      }
    });
  },
  resetToEdit({ commit, dispatch }, orderID) {
    return new Promise((resolve, reject) => {
      var response = HTTP.put('Order/resetOrderToEdit/' + orderID);
      response
        .then((data) => {
          commit('setOrder', data.data);
          dispatch(
            'setMessage',
            new httpError({
              message: 'Order reset for editing',
              httpStatus: 200,
            })
          );
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error updating ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
  },
  sendSQRequest({ dispatch }, address) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post('Order/sendSQ', {
        address: address.formatted_address,
        services: address.services,
      });
      response
        .then((response) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Message sent',
              httpStatus: 500,
            })
          );
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error sending message ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
    // return new Promise((resolve, reject) => {
    //   var response = HTTP.post(
    //     "SQ/sendSQ/"  + rootState.orders.dealer.dealer.dealerID, address
    //   );
    //   response
    //   .then()
    //   .catch();
  },
  sendSQRequestNew({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post('Order/sendSQNew', {
        address: payload.address.formatted_address,
        services: payload.address.services,
        speed: payload.speed,
      });
      response
        .then((response) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Message sent',
              httpStatus: 500,
            })
          );
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error sending message ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
  },
  getAdminRows({ dispatch }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get('Order/GetIPRowsByOrder/');
      response
        .then((response) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Rows attained',
              httpStatus: 500,
            })
          );
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error sending message ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
  },
  updateAdminRows({ dispatch }, rows) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post('Order/UpdateRowsFromAdmin', rows);
      response
        .then((response) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Rows attained',
              httpStatus: 500,
            })
          );
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error sending message ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
  },
  sendUpdatedMacs({ dispatch }, element) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post('Docusign/SendUpdatedMacAddress', element);
      response
        .then((response) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Rows attained',
              httpStatus: 500,
            })
          );
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error sending message ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
  },
  duplicateOrder({ commit, dispatch }, orderId) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(`Order/DuplicateOrder/${orderId}`);
      response
        .then((response) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Success',
              httpStatus: 200,
            })
          );
          let order = new Order(response.data);
          commit('setOrder', order);
          resolve(order);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error sending message ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
  },
  uploadFilesToTicket({ commit, dispatch }, orderId) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post('Docusign/UploadFilesToOrderTicket/' + orderId); // 4 = cancelled
      response
        .then(function (data) {
          var resultData = data.data;
          commit('setOrder', resultData);
          dispatch(
            'setMessage',
            new httpError({
              message: 'Order :' + orderId + ' has been updated.',
              httpStatus: 200,
            })
          );
          resolve(resultData);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  updateOrderSignedDate({ commit, dispatch }, orderId) {
    return new Promise((resolve, reject) => {
      var response = HTTP.put('Order/UpdateOrderSignedDate/' + orderId); // 4 = cancelled
      response
        .then(function (data) {
          var resultData = data.data;
          if (resultData.orderStatus == 4) {
            HTTP.put('Docusign/VoidDocusignEnvelope/' + orderId)
              .then(() => {
                resolve(resultData);
              })
              .catch((err) => {
                reject(err);
              });
          }
          commit('setOrder', resultData);
          dispatch(
            'setMessage',
            new httpError({
              message: 'Order :' + orderId + ' has been updated.',
              httpStatus: 200,
            })
          );
          resolve(resultData);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
};

const mutations = {
  SET_ROUTE(state, route) {
    state.route = route;
  },
  setIsQuote(state, data) {
    state.isQuote = data;
  },
  setQuoteToolFlag(state, data) {
    state.quoteToolFlag = data;
  },
  setFlags(state, data) {
    state.flags = data;
  },
  setAddSoftphone(state, addSoftPhone) {
    state.addSoftPhone = addSoftPhone;
  },
  setIPOrder(state, ipOrderID) {
    state.rows[0].ipOrderID = ipOrderID;
  },
  setOrder(state, order) {
    if (typeof order !== 'undefined') state.rows.splice(0, 1, order);
    state.isSoftPhone = state.isSoftPhone ? state.isSoftPhone : false;
  },
  setOrderType(state, type) {
    state.rows[0].orderType = type;
  },
  setOrderTicket(state, ticket) {
    state.rows[0].kayakoConversation = ticket;
  },
  setOrderEnvelope(state, envelopeID) {
    state.rows[0].docuSignEnvelopeID = envelopeID;
  },
  setOrderStatus(state, status) {
    state.rows[0].orderStatus = status;
  },
  setProgress(state, message) {
    state.message = message;
  },
  setLandline(state, landlineID) {
    state.rows[0].landlineID = landlineID;
  },
  setSignature(state, signature) {
    state.rows[0].signature = signature;
    state.rows[0].orderStatus = 2;
  },
  setResidential(state, flag) {
    state.residential = flag;
  },
  setHardware(state, hardwareID) {
    state.rows[0].hardwareID = hardwareID;
  },
  setDirectDebit(state, directDebit) {
    state.rows[0].directDebit = directDebit;
  },
  setFinanceHardware(state, financedHardware) {
    state.rows[0].financedHardware = financedHardware;
  },
  setExistingCust(state) {
    state.rows[0].existingCustomer = true;
  },
  setOrderContacts(state, contacts) {
    state.rows[0].contacts = contacts;
  },
  removeContact(state, contact) {
    state.rows[0].contacts.splice(state.rows[0].contacts.indexOf(contact), 1);
  },
  setReprocessOrderDialog(state, status) {
    state.reprocessOrderDialog = status;
  },
  setSignedDate(state, date) {
    state.rows[0].signedDate = date;
  },
  updateField,
  setIsUsingExistingDirectDebit(state, status) {
    state.rows[0].isUsingExistingDirectDebit = status;
  },
  setIsReporting(state, status) {
    state.rows[0].isReporting = status;
  },
  setRequiredFields(state, data) {
    state.required_fields = data;
  },
  setPayWithCreditCard(state, status) {
    state.rows[0].directDebit.payWithCreditCard = status;
  },
  setHasDirectDebit(state, status) {
    state.rows[0].directDebit.hasDirectDebit = status;
  },
  setDDOption(state, status) {
    state.rows[0].directDebit.option = status;
  },
  setIsDirectSales(state, data) {
    state.isDirectSales = data;
  },
};

const getters = {
  getRoute: (state) => state.route,
  flags: (state) => state.flags,
  totalCost: (rootState) => {
    let result = rootState.ipVoice.rows
    .filter((x) => !x.rentalHardware)
      .map((x) =>
        rootState.ipVoice.handsets
          .filter((y) => y.handsetID == x.handsetID)
          .reduce((a, c) => parseFloat(c.rrpEx * 1.1) + a, 0.0)
      )
      .reduce((a, c) => parseFloat(a + c), 0.0);

    let rowCount = rootState.ipVoice.rows
      .filter((x) => !x.rentalHardware)
      .map((x) =>
        rootState.ipVoice.handsets
          .filter((y) => y.handsetID == x.handsetID)
          .reduce((a, c) => (parseFloat(c.rrpEx) > 0 ? 1 : 0) + a, 0.0)
      )
      .reduce((a, c) => parseFloat(a + c), 0.0);
    let freight = rowCount == 0 ? 0.0 : (rowCount - 1) * 7.5 + 20.0;
    return result + freight;
  },
  isLoggedIn: (state) => state.auth.isAuthenticated,
  hasOrder: (state) => state.auth.isAuthenticated && state.rows[0].orderID > 0,
  hasSignature: (state) =>
    state.auth.isAuthenticated && state.rows[0].signature,
  hasDealer: (state) =>
    state.auth.isAuthenticated &&
    state.dealer.dealer &&
    state.dealer.dealer.dealerID > 0,
  isAdmin: (state, getters, rootState, rootGetters) =>
    state.auth.isAuthenticated &&
    rootGetters['orders/authGroup'] == 'Administrators' &&
    rootGetters['orders/authLevel'] == 'Admin',
  isDirectSales: (state) => state.isDirectSales,
  authGroup: (state) => state.dealer.dealer.authGroup,
  authLevel: (state) => state.dealer.dealer.authLevel,
  hasAddress: (state) =>
    state.auth.isAuthenticated && state.address.address.addressID > 0,
  hasCustomer: (state) =>
    state.auth.isAuthenticated && state.customer.customer !== null,
  isSigned: (state) =>
    state.auth.isAuthenticated && state.rows[0].orderStatus > 0,
  isExistingCustomer: (state) =>
    state.rows && state.rows[0] && state.rows[0].existingCustomer,
  isResidential: (state) => state.residential,
  isChangeOfAddress: (state) => state.rows[0].orderType === 1,
  isChangeOfLessee: (state) => state.rows[0].orderType === 2,
  isQantas: (state) => state.rows[0].orderType === 3,
  isSoftPhone: (state) => state.addSoftPhone,
  isQuote: (state) => state.isQuote,
  quoteToolFlag: (state) => state.quoteToolFlag,
  isGrenke: (state) => {
    if (state.ipVoice.rows && state.ipVoice.rows.length == 0) return false;
    if (state.ratePlan.rows && state.ratePlan.rows.length == 0) return false;
    let plans = state.ipVoice.rows.map((x) => x.ratePlanID);
    return state.ratePlan.rows
      .filter((x) => plans.includes(x.ratePlanID))
      .some((y) => y.grenkeFinance === true);
  },
  // specific ordertype (Financed Hardware Order) triggered -- SOG-2934
  isFinance: (state) => {
    if (state.rows[0].orderType === 4) return true;
    return false;
  },
  // radio button selection triggered -- SOG-3160
  isFinancedHardware: (state) => {
    if (state.rows[0].financedHardware) return true;
    return false;
  },
  // any other product to allow any order as financed
  financeServices: (state) => {
    if (
      state.Teams.teams.teamsRows &&
      state.Teams.teams.teamsRows.length > 0 &&
      state.Teams.teams.teamsRows.every((x) => x.handsetID !== 0)
    )
      return true;
    return false;
  },
  hasIP: (state) => {
    if (state.ipVoice.iporder.orderID == 0) return false;
    else if (state.ipVoice.ratePlans.length == 0) return false;
    else {
      let plans = state.ipVoice.rows.map((x) => x.ratePlanID);
      return state.ipVoice.ratePlans
        .filter((x) => plans.includes(x.ratePlanID))
        .some((y) => y.usageType === 'VoIP');
    }
  },
  orderID: (state) => state.rows[0].orderID,
  getField,
  reprocessOrderDialog: (state) => state.reprocessOrderDialog,
  isUsingExistingDirectDebit: (state) =>
    state.rows[0].isUsingExistingDirectDebit,
  isReporting: (state) => state.rows[0].isReporting,
  contacts: (state) => state && state.rows && state.rows[0].contacts,
  isPayingWithCreditCard: (state) =>
    state.rows[0].directDebit.payWithCreditCard,
  isUserMember: (state) =>
    state.dealer.dealer &&
    state.dealer.dealer.authGroup == 'Administrators' &&
    state.dealer.dealer.authLevel == 'Admin',
  hasExistingDD: (state) => state.rows[0].directDebit.hasDirectDebit,
  hasNoDDProvided: (state) => state.rows[0].directDebit.noDetailsProvided,
  ddOption: (state) => state.rows[0].directDebit.option,
};

const state = {
  rows: [new Order()],
  addSoftPhone: false,
  qantasOrder: false,
  residential: false,
  isQuote: false,
  quoteToolFlag: null,
  message: new httpError(),
  reprocessOrderDialog: false,
  required_fields: [],
  flags: null,
  route: null,
  isDirectSales: false,
};

const modules = {
  // order, auth,
  auth,
  dealer,
  address,
  company,
  customer,
  newChurn,
  landline,
  ratePlan,
  summary,
  isdn,
  pstn,
  ipVoice,
  notes,
  internet,
  otherCharges,
  hardware,
  handset,
  termsConditions,
  porting,
  uploads,
  Sip,
  Teams,
  mobile,
  inbound,
  menu,
  fax,
  Cmc,
  routes,
  dealerPortal,
  financeApplication,
  relocation,
  changeLessee,
  utility,
  notifications,
  audit,
  qantas,
  quote,
  sq,
  sqAddress,
  featureFlag,
  installationCharges,
};
export const { mapMultiRowFields: mapFinanceApplicationMultiRowFields } =
  createHelpers({
    getterType: 'orders/financeApplication/getField',
    mutationType: 'orders/financeApplication/updateField',
  });
export const { mapFields: mapDealerPortalFields } = createHelpers({
  getterType: `orders/dealerPortal/getField`,
  mutationType: `orders/dealerPortal/updateField`,
});
export const { mapMultiRowFields: mapDealerPortalMultiRowFields } =
  createHelpers({
    getterType: 'orders/dealerPortal/getField',
    mutationType: 'orders/dealerPortal/updateField',
  });

export const { mapFields: mapVueRoutesFields } = createHelpers({
  getterType: `orders/routes/getField`,
  mutationType: `orders/routes/updateField`,
});
export const { mapMultiRowFields: mapVueRoutesMultiRowFields } = createHelpers({
  getterType: 'orders/routes/getField',
  mutationType: 'orders/routes/updateField',
});

export const { mapFields: mapCmcFields } = createHelpers({
  getterType: `orders/Cmc/getField`,
  mutationType: `orders/Cmc/updateField`,
});
export const { mapMultiRowFields: mapCmcMultiRowFields } = createHelpers({
  getterType: 'orders/Cmc/getField',
  mutationType: 'orders/Cmc/updateField',
});

export const { mapFields: mapFaxFields } = createHelpers({
  getterType: `orders/fax/getField`,
  mutationType: `orders/fax/updateField`,
});
export const { mapMultiRowFields: mapFaxMultiRowFields } = createHelpers({
  getterType: 'orders/fax/getField',
  mutationType: 'orders/fax/updateField',
});

export const { mapFields: mapMenuFields } = createHelpers({
  getterType: `orders/menu/getField`,
  mutationType: `orders/menu/updateField`,
});
export const { mapMultiRowFields: mapMenuMultiRowFields } = createHelpers({
  getterType: 'orders/menu/getField',
  mutationType: 'orders/menu/updateField',
});

export const { mapFields: mapInboundFields } = createHelpers({
  getterType: `orders/inbound/getField`,
  mutationType: `orders/inbound/updateField`,
});
export const { mapMultiRowFields: mapInboundMultiRowFields } = createHelpers({
  getterType: 'orders/inbound/getField',
  mutationType: 'orders/inbound/updateField',
});

export const { mapFields: mapMobileFields } = createHelpers({
  getterType: `orders/mobile/getField`,
  mutationType: `orders/mobile/updateField`,
});
export const { mapMultiRowFields: mapMobileMultiRowFields } = createHelpers({
  getterType: 'orders/mobile/getField',
  mutationType: 'orders/mobile/updateField',
});

export const { mapFields: mapSipFields } = createHelpers({
  getterType: `orders/Sip/getField`,
  mutationType: `orders/Sip/updateField`,
});
export const { mapMultiRowFields: mapSipMultiRowFields } = createHelpers({
  getterType: 'orders/Sip/getField',
  mutationType: 'orders/Sip/updateField',
});

export const { mapFields: mapTeamsFields } = createHelpers({
  getterType: `orders/Teams/getField`,
  mutationType: `orders/Teams/updateField`,
});
export const { mapMultiRowFields: mapTeamsMultiRowFields } = createHelpers({
  getterType: 'orders/Teams/getField',
  mutationType: 'orders/Teams/updateField',
});

export const { mapFields: mapUploadFields } = createHelpers({
  getterType: `orders/uploads/getField`,
  mutationType: `orders/uploads/updateField`,
});
export const { mapMultiRowFields: mapUploadMultiRowFields } = createHelpers({
  getterType: 'orders/uploads/getField',
  mutationType: 'orders/uploads/updateField',
});

export const { mapFields: mapPortingFields } = createHelpers({
  getterType: `orders/porting/getField`,
  mutationType: `orders/porting/updateField`,
});

export const { mapMultiRowFields: mapPortingMultiRowFields } = createHelpers({
  getterType: 'orders/porting/getField',
  mutationType: 'orders/porting/updateField',
});
export const { mapFields: mapTermsConditionsFields } = createHelpers({
  getterType: `orders/termsConditions/getField`,
  mutationType: `orders/termsConditions/updateField`,
});

export const { mapMultiRowFields: mapTermsConditionsMultiRowFields } =
  createHelpers({
    getterType: 'orders/termsConditions/getField',
    mutationType: 'orders/termsConditions/updateField',
  });

export const { mapFields: mapRatePlanFields } = createHelpers({
  getterType: `orders/ratePlan/getField`,
  mutationType: `orders/ratePlan/updateField`,
});

export const { mapFields: mapAuthFields } = createHelpers({
  getterType: `orders/auth/getField`,
  mutationType: `orders/auth/updateField`,
});

export const { mapFields: mapDealerFields } = createHelpers({
  getterType: `orders/dealer/getField`,
  mutationType: `orders/dealer/updateField`,
});

export const { mapFields: mapCompanyFields } = createHelpers({
  getterType: `orders/company/getField`,
  mutationType: `orders/company/updateField`,
});

export const { mapFields: mapCustomerFields } = createHelpers({
  getterType: `orders/customer/getField`,
  mutationType: `orders/customer/updateField`,
});
export const { mapFields: mapNewChurnFields } = createHelpers({
  getterType: `orders/newChurn/getField`,
  mutationType: `orders/newChurn/updateField`,
});

export const { mapMultiRowFields: mapNewChurnMultiRowFields } = createHelpers({
  getterType: 'orders/newChurn/getField',
  mutationType: 'orders/newChurn/updateField',
});

export const { mapFields: mapLandlineFields } = createHelpers({
  getterType: `orders/landline/getField`,
  mutationType: `orders/landline/updateField`,
});

export const { mapMultiRowFields: mapLandlineMultiRowFields } = createHelpers({
  getterType: 'orders/landline/getField',
  mutationType: 'orders/landline/updateField',
});

export const { mapFields: mapAddressFields } = createHelpers({
  getterType: `orders/address/getField`,
  mutationType: `orders/address/updateField`,
});
export const { mapMultiRowFields: mapAddressMultiRowFields } = createHelpers({
  getterType: 'orders/address/getField',
  mutationType: 'orders/address/updateField',
});

export const { mapMultiRowFields: mapRatePlanMultiRowFields } = createHelpers({
  getterType: 'orders/ratePlan/getField',
  mutationType: 'orders/ratePlan/updateField',
});
export const { mapFields: mapSummaryFields } = createHelpers({
  getterType: `orders/summary/getField`,
  mutationType: `orders/summary/updateField`,
});
export const { mapMultiRowFields: mapNewISDNMultiRowFields } = createHelpers({
  getterType: `orders/isdn/getField`,
  mutationType: `orders/isdn/updateField`,
});

export const { mapFields: mapNewISDNFields } = createHelpers({
  getterType: `orders/isdn/getField`,
  mutationType: `orders/isdn/updateField`,
});

export const { mapFields: mapNewPSTNFields } = createHelpers({
  getterType: `orders/pstn/getField`,
  mutationType: `orders/pstn/updateField`,
});

export const { mapMultiRowFields: mapNewPSTNMultiRowFields } = createHelpers({
  getterType: 'orders/pstn/getField',
  mutationType: 'orders/pstn/updateField',
});

export const { mapFields: mapIPVoiceFields } = createHelpers({
  getterType: `orders/ipVoice/getField`,
  mutationType: `orders/ipVoice/updateField`,
});

export const { mapFields: mapChangeLessee } = createHelpers({
  getterType: `orders/changeLessee/getField`,
  mutationType: `orders/changeLessee/updateField`,
});

export const { mapMultiRowFields: mapIPVoiceMultiRowFields } = createHelpers({
  getterType: 'orders/ipVoice/getField',
  mutationType: 'orders/ipVoice/updateField',
});

export const { mapFields: mapNoteFields } = createHelpers({
  getterType: `orders/notes/getField`,
  mutationType: `orders/notes/updateField`,
});

export const { mapMultiRowFields: mapNoteMultiRowFields } = createHelpers({
  getterType: 'orders/notes/getField',
  mutationType: 'orders/notes/updateField',
});

export const { mapMultiRowFields: mapDealerMultiRowFields } = createHelpers({
  getterType: 'orders/dealer/getField',
  mutationType: 'orders/dealer/updateField',
});

export const { mapMultiRowFields: mapInternetMultiRowFields } = createHelpers({
  getterType: 'orders/internet/getField',
  mutationType: 'orders/internet/updateField',
});

export const { mapMultiRowFields: mapOtherChargesMultiRowFields } =
  createHelpers({
    getterType: 'orders/otherCharges/getField',
    mutationType: 'orders/otherCharges/updateField',
  });

export const { mapMultiRowFields: mapHardwareMultiRowFields } = createHelpers({
  getterType: 'orders/hardware/getField',
  mutationType: 'orders/hardware/updateField',
});

export const { mapFields: mapHardwareFields } = createHelpers({
  getterType: `orders/hardware/getField`,
  mutationType: `orders/hardware/updateField`,
});

export const { mapFields: mapInternetFields } = createHelpers({
  getterType: `orders/internet/getField`,
  mutationType: `orders/internet/updateField`,
});

//handset
export const { mapMultiRowFields: mapHandsetMultiRowFields } = createHelpers({
  getterType: 'orders/handset/getField',
  mutationType: 'orders/handset/updateField',
});

export const { mapFields: mapHandsetFields } = createHelpers({
  getterType: `orders/handset/getField`,
  mutationType: `orders/handset/updateField`,
});
export const { mapFields: mapFinanceApplicationFields } = createHelpers({
  getterType: `orders/financeApplication/getField`,
  mutationType: `orders/financeApplication/updateField`,
});
export const { mapFields: mapQuoteMultiRowFields } = createHelpers({
  getterType: `orders/quote/getField`,
  mutationType: `orders/quote/updateField`,
});

export const { mapFields: mapFeatureFlagFields } = createHelpers({
  getterType: `orders/featureFlag/getField`,
  mutationType: `orders/featureFlag/updateField`,
});
export const { mapMultiRowFields: mapFeatureFlagMultiRowFields } =
  createHelpers({
    getterType: 'orders/featureFlag/getField',
    mutationType: 'orders/featureFlag/updateField',
  });

export const { mapFields: mapInstallationChargesFields } = createHelpers({
  getterType: `orders/installationCharges/getField`,
  mutationType: `orders/installationCharges/updateField`,
});

export const { mapFields: mapOtherChargesFields } = createHelpers({
  getterType: `orders/otherCharges/getField`,
  mutationType: `orders/otherCharges/updateField`,
});

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
};
